const kakaoApiClientId =
  process.env.REACT_APP_MODUSIGN_ENV === 'production'
    ? '95dec7a7b9fc0da0713b0674d05f09a6' // https://developers.kakao.com/console/app/771229
    : '453f28b097b6efe85cf7ab1e3f6d09f7'; // https://developers.kakao.com/console/app/772600

export default kakaoApiClientId;
